'use strict';

var React = require('react');

var SvgColorNoneIcon = function SvgColorNoneIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m9.524 3.67-.002.002-.004.003-.012.01-.042.036a17.321 17.321 0 0 0-.686.624c-.438.42-1.023 1.02-1.61 1.743-1.146 1.411-2.418 3.43-2.418 5.542 0 .69.118 1.342.335 1.937l1.223-1.224a4.322 4.322 0 0 1-.058-.713c0-1.566.978-3.237 2.082-4.596a17.879 17.879 0 0 1 1.668-1.78c.057.053.119.11.184.173.4.384.93.929 1.461 1.58l1.066-1.066a19.522 19.522 0 0 0-2.175-2.22l-.042-.036-.012-.01-.004-.003-.002-.001a.75.75 0 0 0-.953 0Zm.476.58.476-.58-.476.58Zm-.476-.58.476.58Zm0 0s0 .002.06.073Zm.06.073.416.507Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m13.803 6.97-8.273 8.273-.002.002a.75.75 0 0 0 1.063 1.058l.308-.307a5.216 5.216 0 0 0 3.101 1.004c2 0 3.75-1.093 4.636-2.798a5.557 5.557 0 0 0 .614-2.572c0-1.099-.345-2.173-.836-3.15l.45-.45a.75.75 0 0 0-1.06-1.06Zm-3.803 8.53a3.74 3.74 0 0 1-2.023-.583l5.309-5.308c.287.671.464 1.356.464 2.021 0 .704-.164 1.339-.445 1.88a3.683 3.683 0 0 1-3.305 1.99Z"
  }));
};
SvgColorNoneIcon.displayName = "ColorNoneIcon";

exports.SvgColorNoneIcon = SvgColorNoneIcon;
